module.exports = ".disable-btn {\n  pointer-events: none; }\n\n.add-file-wrapper.disable-btn label:hover:before {\n  color: transparent; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/jobs/common/btn-add-file/btn-add-file.scss
// module id = ./web/modern/components/jobs/common/btn-add-file/btn-add-file.scss
// module chunks = 0